import * as React from "react";
import useApi from "@/hooks/useApi";

/**
 * Checks whether this site has a KB tenant linked.
 * If not linked, redirects to /kb/setup automatically.
 * All KB admin pages use this so users always see setup instead of empty data.
 */
export default function useKBConnection() {
  const [connected, setConnected] = React.useState<boolean | null>(null);
  const api = useApi();

  React.useEffect(() => {
    async function check() {
      try {
        const response = await api.admin.get("api/kb/tenants/current");
        if (response.ok) {
          setConnected(true);
        } else if (response.status === 404) {
          // No KB tenant linked — redirect to setup
          window.location.href = "/kb/setup";
        } else {
          // Unknown error — still show the page (don't redirect on 500)
          setConnected(true);
        }
      } catch {
        setConnected(true); // network error — don't block the page
      }
    }
    check();
  }, []);

  return { connected };
}
